import React, { FC, useEffect, useRef, useState } from "react";
import { Col, Row, Container } from "reactstrap";

import Button from "@material-ui/core/Button";

import { Spinner } from "reactstrap";
// import TablePagination from "@material-ui/core/TablePagination";
import TablePagination from "@material-ui/core/TablePagination";
import GetApp from "@material-ui/icons/GetApp";
import { initReactI18next, useTranslation } from "react-i18next";
import CircularProgress from "@material-ui/core/CircularProgress";


import { makeStyles, useTheme } from "@material-ui/core/styles";

import LoadingButton from "@material-ui/lab/LoadingButton/LoadingButton";
// import LoadingButton from "../../modules/LoadingButton/index";

const App = ({
  dispatch_get,
  inLoading,
  searchHistoriesTransactions,
  set_searchHistoriesTransactions,
  total_count,
}) => {
  const [t, i18n] = useTranslation();

  useEffect(() => {
    dispatch_get({
      ...searchHistoriesTransactions._search,
      page: 1,
    });
  }, []);

  const handleChangeSearch = () => {
    dispatch_get({
      ...searchHistoriesTransactions._search,
      page: 1,
    });
    set_searchHistoriesTransactions({
      _search: { ...searchHistoriesTransactions._search, page: 1 },
    });
  };

  const handleChangePage = (event, newPage) => {
    dispatch_get({
      ...searchHistoriesTransactions._search,
      page: newPage + 1,
    });

    set_searchHistoriesTransactions({
      _search: { ...searchHistoriesTransactions._search, page: newPage + 1 },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch_get({
      ...searchHistoriesTransactions._search,
      limit: parseInt(event.target.value, 10),
      page: 1,
    });

    set_searchHistoriesTransactions({
      _search: {
        ...searchHistoriesTransactions._search,
        limit: parseInt(event.target.value, 10),
        page: 1,
      },
    });
  };

  const theme = useTheme();
  const primary = theme.palette.primary.main;

  return (
    <>
      <Container fluid>
        <Row className="d-flex flex-row justify-content-between align-items-center pl-3">
          <LoadingButton
            onClick={handleChangeSearch}
            pending={inLoading}
            // variant="outlined"
            variant="contained"
            style={{
              backgroundColor: primary,
              color: "white",
            }}
          >
            {t("検索")}
          </LoadingButton>
            <TablePagination
              // rowsPerPageOptions={[5, 10, 50]}
              rowsPerPageOptions={[10]}
              labelRowsPerPage={t("行数")}
              // labelRowsPerPage="行数"
              // labelDisplayedRows={({ from, to, count }) =>
              //   `${count} 件中 ${from} ~ ${to} 件表示`
              // }
              labelDisplayedRows={({ from, to, count }) =>
              inLoading ? "" :`${from} ~ ${to} of ${count}`
              }
              component="div"
              count={inLoading ? 0 : total_count}
              page={searchHistoriesTransactions._search.page - 1}
              onChangePage={handleChangePage}
              rowsPerPage={inLoading ? 0 :searchHistoriesTransactions._search.limit}
              // onChangeRowsPerPage={handleChangeRowsPerPage}
              // onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Row>
      </Container>
    </>
  );
};

export default App;
